// Generated from ironlog-ios/tests/fixtures/program-catalog.json.
// Run ironlog-ios/tests/generate-native-catalogs.mjs; do not edit.
export const PROGRAMS = [
  {
    "id": "sl5x5",
    "name": "StrongLifts 5×5",
    "summary": "Beginner strength · 3 days/week · alternating A/B",
    "weeks": 12,
    "level": "Beginner",
    "progression": "double",
    "weekly": [
      0,
      null,
      1,
      null,
      0,
      null,
      null
    ],
    "days": 3,
    "rotation": [
      {
        "name": "Workout A",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 5,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "bench",
            "sets": 5,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "row",
            "sets": 5,
            "reps": 5,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Workout B",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 5,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "ohp",
            "sets": 5,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "deadlift",
            "sets": 1,
            "reps": 5,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Beginner strength · 3 days/week · alternating A/B",
    "schedule": [
      "Workout A",
      "Rest",
      "Workout B",
      "Rest",
      "Workout A",
      "Rest",
      "Rest"
    ],
    "types": [
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Workout A": [
        "Barbell Squat",
        "Bench Press",
        "Barbell Row"
      ],
      "Workout B": [
        "Barbell Squat",
        "Overhead Press",
        "Deadlift"
      ]
    }
  },
  {
    "id": "ppl6",
    "name": "Push / Pull / Legs",
    "summary": "Hypertrophy · 6 days/week",
    "weeks": 8,
    "level": "Intermediate",
    "progression": "double",
    "weekly": [
      0,
      1,
      2,
      0,
      1,
      2,
      null
    ],
    "days": 6,
    "rotation": [
      {
        "name": "Push",
        "type": "Push",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 4,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "ohp",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "incbench",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Pull",
        "type": "Pull",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "row",
            "sets": 4,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "latpull",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "dbrow",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Legs",
        "type": "Legs",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 4,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "legpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "rdl",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Hypertrophy · 6 days/week",
    "schedule": [
      "Push",
      "Pull",
      "Legs",
      "Push",
      "Pull",
      "Legs",
      "Rest"
    ],
    "types": [
      "Push",
      "Pull",
      "Legs",
      "Push",
      "Pull",
      "Legs",
      "Rest"
    ],
    "exercises": {
      "Push": [
        "Bench Press",
        "Overhead Press",
        "Incline Bench Press",
        "Lateral Raise",
        "Tricep Pushdown"
      ],
      "Pull": [
        "Deadlift",
        "Barbell Row",
        "Lat Pulldown",
        "Dumbbell Row",
        "Bicep Curl"
      ],
      "Legs": [
        "Barbell Squat",
        "Leg Press",
        "Romanian Deadlift",
        "Seated Leg Curl",
        "Calf Raise"
      ]
    }
  },
  {
    "id": "ul4",
    "name": "Upper / Lower",
    "summary": "Balanced strength + size · 4 days/week",
    "weeks": 8,
    "level": "Intermediate",
    "progression": "double",
    "weekly": [
      0,
      1,
      null,
      2,
      3,
      null,
      null
    ],
    "days": 4,
    "rotation": [
      {
        "name": "Upper A",
        "type": "Upper",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 4,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "row",
            "sets": 4,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "ohp",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "latpull",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Lower A",
        "type": "Lower",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 4,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "rdl",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "legpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 15,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Upper B",
        "type": "Upper",
        "exercises": [
          {
            "exerciseId": "incbench",
            "sets": 4,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "cablerow",
            "sets": 4,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "dip",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Lower B",
        "type": "Lower",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "frontsquat",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "lunge",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "hipthrust",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "seatcalf",
            "sets": 4,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Balanced strength + size · 4 days/week",
    "schedule": [
      "Upper A",
      "Lower A",
      "Rest",
      "Upper B",
      "Lower B",
      "Rest",
      "Rest"
    ],
    "types": [
      "Upper",
      "Lower",
      "Rest",
      "Upper",
      "Lower",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Upper A": [
        "Bench Press",
        "Barbell Row",
        "Overhead Press",
        "Lat Pulldown",
        "Bicep Curl"
      ],
      "Lower A": [
        "Barbell Squat",
        "Romanian Deadlift",
        "Leg Press",
        "Seated Leg Curl",
        "Calf Raise"
      ],
      "Upper B": [
        "Incline Bench Press",
        "Seated Cable Row",
        "Lateral Raise",
        "Dips",
        "Tricep Pushdown"
      ],
      "Lower B": [
        "Deadlift",
        "Front Squat",
        "Lunges",
        "Hip Thrust",
        "Seated Calf Raise"
      ]
    }
  },
  {
    "id": "fb3",
    "name": "Full-Body Foundations",
    "summary": "Novice-friendly · 3 days/week · every muscle, every session",
    "weeks": 8,
    "level": "Beginner",
    "progression": "double",
    "weekly": [
      0,
      null,
      1,
      null,
      2,
      null,
      null
    ],
    "days": 3,
    "rotation": [
      {
        "name": "Day A",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "bench",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "latpull",
            "sets": 3,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "hangleg",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 2,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Day B",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "ohp",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "cablerow",
            "sets": 3,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "lunge",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 2,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Day C",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "frontsquat",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "dbbench",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "pullup",
            "sets": 3,
            "reps": 8,
            "repLow": 5
          },
          {
            "exerciseId": "rdl",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Novice-friendly · 3 days/week · every muscle, every session",
    "schedule": [
      "Day A",
      "Rest",
      "Day B",
      "Rest",
      "Day C",
      "Rest",
      "Rest"
    ],
    "types": [
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Day A": [
        "Barbell Squat",
        "Bench Press",
        "Lat Pulldown",
        "Hanging Leg Raise",
        "Bicep Curl"
      ],
      "Day B": [
        "Deadlift",
        "Overhead Press",
        "Seated Cable Row",
        "Lunges",
        "Tricep Pushdown"
      ],
      "Day C": [
        "Front Squat",
        "Dumbbell Bench Press",
        "Pull-ups",
        "Romanian Deadlift",
        "Lateral Raise"
      ]
    }
  },
  {
    "id": "big4",
    "name": "Big-4 Strength",
    "summary": "5/3/1-style · 4 days/week · one main lift per day + volume",
    "weeks": 12,
    "level": "Intermediate",
    "progression": "double",
    "weekly": [
      0,
      1,
      null,
      2,
      3,
      null,
      null
    ],
    "days": 4,
    "rotation": [
      {
        "name": "Press Day",
        "type": "Shoulders",
        "exercises": [
          {
            "exerciseId": "ohp",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "dip",
            "sets": 5,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 12
          },
          {
            "exerciseId": "facepull",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Deadlift Day",
        "type": "Back",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "rdl",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "hangleg",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "hyperext",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Bench Day",
        "type": "Chest",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "dbbench",
            "sets": 5,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Squat Day",
        "type": "Legs",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "legpress",
            "sets": 5,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "5/3/1-style · 4 days/week · one main lift per day + volume",
    "schedule": [
      "Press Day",
      "Deadlift Day",
      "Rest",
      "Bench Day",
      "Squat Day",
      "Rest",
      "Rest"
    ],
    "types": [
      "Shoulders",
      "Back",
      "Rest",
      "Chest",
      "Legs",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Press Day": [
        "Overhead Press",
        "Dips",
        "Lateral Raise",
        "Face Pull"
      ],
      "Deadlift Day": [
        "Deadlift",
        "Romanian Deadlift",
        "Hanging Leg Raise",
        "Hyperextension"
      ],
      "Bench Day": [
        "Bench Press",
        "Dumbbell Bench Press",
        "Tricep Pushdown",
        "Bicep Curl"
      ],
      "Squat Day": [
        "Barbell Squat",
        "Leg Press",
        "Seated Leg Curl",
        "Calf Raise"
      ]
    }
  },
  {
    "id": "dbhome",
    "name": "Dumbbell Home",
    "summary": "A pair of dumbbells and a bench · 3 days/week",
    "weeks": 6,
    "level": "Beginner",
    "progression": "double",
    "weekly": [
      0,
      null,
      1,
      null,
      2,
      null,
      null
    ],
    "days": 3,
    "rotation": [
      {
        "name": "Home A",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "goblet",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "dbbench",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "dbrow",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "dblateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "crunch",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Home B",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "dbrdl",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "dbohp",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "dbincbench",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "hammercurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "deadbug",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Home C",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "walkinglunge",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "dbrow",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "arnoldpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "inclinecurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "dbtricext",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "A pair of dumbbells and a bench · 3 days/week",
    "schedule": [
      "Home A",
      "Rest",
      "Home B",
      "Rest",
      "Home C",
      "Rest",
      "Rest"
    ],
    "types": [
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Home A": [
        "Goblet Squat",
        "Dumbbell Bench Press",
        "Dumbbell Row",
        "Seated DB Lateral Raise",
        "Crunches"
      ],
      "Home B": [
        "Dumbbell RDL",
        "DB Shoulder Press",
        "Incline DB Press",
        "Hammer Curl",
        "Dead Bug"
      ],
      "Home C": [
        "Walking Lunge",
        "Dumbbell Row",
        "Arnold Press",
        "Incline DB Curl",
        "DB Overhead Tricep Ext"
      ]
    }
  },
  {
    "id": "bwfound",
    "name": "Bodyweight Foundations",
    "summary": "No equipment needed · 3 days/week · master your own weight",
    "weeks": 4,
    "level": "Beginner",
    "progression": "double",
    "weekly": [
      0,
      null,
      1,
      null,
      2,
      null,
      null
    ],
    "days": 3,
    "rotation": [
      {
        "name": "Foundations A",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "pushup",
            "sets": 4,
            "reps": 12,
            "repLow": 8
          },
          {
            "exerciseId": "invertedrow",
            "sets": 4,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "bss",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "crunch",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "burpee",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Foundations B",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "dipbw",
            "sets": 3,
            "reps": 12,
            "repLow": 8
          },
          {
            "exerciseId": "chinup",
            "sets": 3,
            "reps": 8,
            "repLow": 5
          },
          {
            "exerciseId": "walkinglunge",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "mtclimber",
            "sets": 3,
            "reps": 20,
            "repLow": 0
          },
          {
            "exerciseId": "hangleg",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Foundations C",
        "type": "Full Body",
        "exercises": [
          {
            "exerciseId": "diamondpush",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "invertedrow",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "stepup",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "glutebridge",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "deadbug",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "No equipment needed · 3 days/week · master your own weight",
    "schedule": [
      "Foundations A",
      "Rest",
      "Foundations B",
      "Rest",
      "Foundations C",
      "Rest",
      "Rest"
    ],
    "types": [
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Full Body",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Foundations A": [
        "Push-ups",
        "Inverted Row",
        "Bulgarian Split Squat",
        "Crunches",
        "Burpees"
      ],
      "Foundations B": [
        "Bodyweight Dip",
        "Chin-ups",
        "Walking Lunge",
        "Mountain Climbers",
        "Hanging Leg Raise"
      ],
      "Foundations C": [
        "Diamond Push-up",
        "Inverted Row",
        "Step Ups",
        "Glute Bridge",
        "Dead Bug"
      ]
    }
  },
  {
    "id": "pwrbld",
    "name": "Powerbuilding",
    "summary": "Heavy top sets + hypertrophy back-off · 4 days/week",
    "weeks": 8,
    "level": "Intermediate",
    "progression": "double",
    "weekly": [
      0,
      1,
      null,
      2,
      3,
      null,
      null
    ],
    "days": 4,
    "rotation": [
      {
        "name": "Squat + Quads",
        "type": "Legs",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 4,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "hacksquat",
            "sets": 3,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "legext",
            "sets": 3,
            "reps": 15,
            "repLow": 12
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Bench + Chest",
        "type": "Chest",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 4,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "incbench",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "pecfly",
            "sets": 3,
            "reps": 15,
            "repLow": 12
          },
          {
            "exerciseId": "skullcrusher",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Deadlift + Back",
        "type": "Back",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "pendlay",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "latpull",
            "sets": 3,
            "reps": 12,
            "repLow": 10
          },
          {
            "exerciseId": "facepull",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "OHP + Delts",
        "type": "Shoulders",
        "exercises": [
          {
            "exerciseId": "ohp",
            "sets": 4,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "dbohp",
            "sets": 3,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "lateralraise",
            "sets": 4,
            "reps": 15,
            "repLow": 12
          },
          {
            "exerciseId": "reardelt",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "hammercurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Heavy top sets + hypertrophy back-off · 4 days/week",
    "schedule": [
      "Squat + Quads",
      "Bench + Chest",
      "Rest",
      "Deadlift + Back",
      "OHP + Delts",
      "Rest",
      "Rest"
    ],
    "types": [
      "Legs",
      "Chest",
      "Rest",
      "Back",
      "Shoulders",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Squat + Quads": [
        "Barbell Squat",
        "Hack Squat",
        "Leg Extension",
        "Calf Raise"
      ],
      "Bench + Chest": [
        "Bench Press",
        "Incline Bench Press",
        "Pec Deck Fly",
        "Skull Crushers",
        "Tricep Pushdown"
      ],
      "Deadlift + Back": [
        "Deadlift",
        "Pendlay Row",
        "Lat Pulldown",
        "Face Pull",
        "Bicep Curl"
      ],
      "OHP + Delts": [
        "Overhead Press",
        "DB Shoulder Press",
        "Lateral Raise",
        "Rear Delt Fly",
        "Hammer Curl"
      ]
    }
  },
  {
    "id": "531",
    "name": "5/3/1 Wendler",
    "weeks": 4,
    "summary": "Four main lifts · 4 days/week · choose main-lift loads from your training max",
    "level": "Intermediate",
    "progression": "manual",
    "weekly": [
      0,
      1,
      null,
      2,
      3,
      null,
      null
    ],
    "days": 4,
    "rotation": [
      {
        "name": "Squat",
        "type": "Legs",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "legpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "abwheel",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Bench",
        "type": "Chest",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "dbrow",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "dbincbench",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Deadlift",
        "type": "Back",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "goodmorning",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "hangleg",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "OHP",
        "type": "Shoulders",
        "exercises": [
          {
            "exerciseId": "ohp",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "chinup",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "facepull",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Four main lifts · 4 days/week · choose main-lift loads from your training max",
    "schedule": [
      "Squat",
      "Bench",
      "Rest",
      "Deadlift",
      "OHP",
      "Rest",
      "Rest"
    ],
    "types": [
      "Legs",
      "Chest",
      "Rest",
      "Back",
      "Shoulders",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Squat": [
        "Barbell Squat",
        "Leg Press",
        "Seated Leg Curl",
        "Ab Wheel Rollout"
      ],
      "Bench": [
        "Bench Press",
        "Dumbbell Row",
        "Incline DB Press",
        "Tricep Pushdown"
      ],
      "Deadlift": [
        "Deadlift",
        "Good Morning",
        "Hanging Leg Raise",
        "Bicep Curl"
      ],
      "OHP": [
        "Overhead Press",
        "Chin-ups",
        "Lateral Raise",
        "Face Pull"
      ]
    }
  },
  {
    "id": "phul",
    "name": "PHUL",
    "weeks": 8,
    "summary": "Power Hypertrophy Upper Lower · strength + size · 4 days/week",
    "level": "Intermediate",
    "progression": "double",
    "weekly": [
      0,
      1,
      null,
      2,
      3,
      null,
      null
    ],
    "days": 4,
    "rotation": [
      {
        "name": "Upper Power",
        "type": "Upper",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 4,
            "reps": 5,
            "repLow": 3
          },
          {
            "exerciseId": "row",
            "sets": 4,
            "reps": 5,
            "repLow": 3
          },
          {
            "exerciseId": "ohp",
            "sets": 3,
            "reps": 8,
            "repLow": 6
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 10,
            "repLow": 8
          },
          {
            "exerciseId": "skullcrusher",
            "sets": 3,
            "reps": 10,
            "repLow": 8
          }
        ]
      },
      {
        "name": "Lower Power",
        "type": "Lower",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 4,
            "reps": 5,
            "repLow": 3
          },
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 3
          },
          {
            "exerciseId": "legpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 10,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Upper Hyper",
        "type": "Upper",
        "exercises": [
          {
            "exerciseId": "dbincbench",
            "sets": 3,
            "reps": 12,
            "repLow": 8
          },
          {
            "exerciseId": "cablerow",
            "sets": 3,
            "reps": 12,
            "repLow": 8
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Lower Hyper",
        "type": "Lower",
        "exercises": [
          {
            "exerciseId": "frontsquat",
            "sets": 3,
            "reps": 12,
            "repLow": 8
          },
          {
            "exerciseId": "rdl",
            "sets": 3,
            "reps": 12,
            "repLow": 8
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "legext",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "Power Hypertrophy Upper Lower · strength + size · 4 days/week",
    "schedule": [
      "Upper Power",
      "Lower Power",
      "Rest",
      "Upper Hyper",
      "Lower Hyper",
      "Rest",
      "Rest"
    ],
    "types": [
      "Upper",
      "Lower",
      "Rest",
      "Upper",
      "Lower",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Upper Power": [
        "Bench Press",
        "Barbell Row",
        "Overhead Press",
        "Bicep Curl",
        "Skull Crushers"
      ],
      "Lower Power": [
        "Barbell Squat",
        "Deadlift",
        "Leg Press",
        "Calf Raise"
      ],
      "Upper Hyper": [
        "Incline DB Press",
        "Seated Cable Row",
        "Lateral Raise",
        "Bicep Curl",
        "Tricep Pushdown"
      ],
      "Lower Hyper": [
        "Front Squat",
        "Romanian Deadlift",
        "Seated Leg Curl",
        "Leg Extension",
        "Calf Raise"
      ]
    }
  },
  {
    "id": "bro5",
    "name": "Bro Split",
    "weeks": 8,
    "summary": "One muscle group per day · Chest, Back, Shoulders, Arms, Legs",
    "level": "Intermediate",
    "progression": "double",
    "weekly": [
      0,
      1,
      2,
      3,
      4,
      null,
      null
    ],
    "days": 5,
    "rotation": [
      {
        "name": "Chest",
        "type": "Chest",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 4,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "dbincbench",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "flye",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "dip",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Back",
        "type": "Back",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 3,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "pullup",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "row",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "latpull",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "facepull",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Shoulders",
        "type": "Shoulders",
        "exercises": [
          {
            "exerciseId": "ohp",
            "sets": 4,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "reardelt",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "shrug",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Arms",
        "type": "Arms",
        "exercises": [
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "hammercurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "skullcrusher",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Legs",
        "type": "Legs",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 4,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "legpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "rdl",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          },
          {
            "exerciseId": "calfraise",
            "sets": 4,
            "reps": 15,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "One muscle group per day · Chest, Back, Shoulders, Arms, Legs",
    "schedule": [
      "Chest",
      "Back",
      "Shoulders",
      "Arms",
      "Legs",
      "Rest",
      "Rest"
    ],
    "types": [
      "Chest",
      "Back",
      "Shoulders",
      "Arms",
      "Legs",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Chest": [
        "Bench Press",
        "Incline DB Press",
        "Cable Flye",
        "Dips"
      ],
      "Back": [
        "Deadlift",
        "Pull-ups",
        "Barbell Row",
        "Lat Pulldown",
        "Face Pull"
      ],
      "Shoulders": [
        "Overhead Press",
        "Lateral Raise",
        "Rear Delt Fly",
        "Dumbbell Shrug"
      ],
      "Arms": [
        "Bicep Curl",
        "Hammer Curl",
        "Skull Crushers",
        "Tricep Pushdown"
      ],
      "Legs": [
        "Barbell Squat",
        "Leg Press",
        "Romanian Deadlift",
        "Seated Leg Curl",
        "Calf Raise"
      ]
    }
  },
  {
    "id": "nsuns",
    "name": "nSuns 5/3/1 LP",
    "weeks": 6,
    "summary": "High-volume main lifts + accessories · 4-day schedule · choose loads from your training max",
    "level": "Intermediate",
    "progression": "manual",
    "weekly": [
      0,
      1,
      null,
      2,
      3,
      null,
      null
    ],
    "days": 4,
    "rotation": [
      {
        "name": "Bench/OHP",
        "type": "Push",
        "exercises": [
          {
            "exerciseId": "bench",
            "sets": 9,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "ohp",
            "sets": 8,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "dbrow",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "lateralraise",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "tricep",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Squat/Sumo",
        "type": "Lower",
        "exercises": [
          {
            "exerciseId": "squat",
            "sets": 9,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "sumo",
            "sets": 8,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "legpress",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          },
          {
            "exerciseId": "legcurl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "OHP/Incline",
        "type": "Push",
        "exercises": [
          {
            "exerciseId": "ohp",
            "sets": 9,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "incbench",
            "sets": 8,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "pullup",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "facepull",
            "sets": 3,
            "reps": 15,
            "repLow": 0
          },
          {
            "exerciseId": "curl",
            "sets": 3,
            "reps": 12,
            "repLow": 0
          }
        ]
      },
      {
        "name": "Deadlift/Front Squat",
        "type": "Lower",
        "exercises": [
          {
            "exerciseId": "deadlift",
            "sets": 9,
            "reps": 5,
            "repLow": 0
          },
          {
            "exerciseId": "frontsquat",
            "sets": 8,
            "reps": 6,
            "repLow": 0
          },
          {
            "exerciseId": "row",
            "sets": 3,
            "reps": 8,
            "repLow": 0
          },
          {
            "exerciseId": "abwheel",
            "sets": 3,
            "reps": 10,
            "repLow": 0
          }
        ]
      }
    ],
    "desc": "High-volume main lifts + accessories · 4-day schedule · choose loads from your training max",
    "schedule": [
      "Bench/OHP",
      "Squat/Sumo",
      "Rest",
      "OHP/Incline",
      "Deadlift/Front Squat",
      "Rest",
      "Rest"
    ],
    "types": [
      "Push",
      "Lower",
      "Rest",
      "Push",
      "Lower",
      "Rest",
      "Rest"
    ],
    "exercises": {
      "Bench/OHP": [
        "Bench Press",
        "Overhead Press",
        "Dumbbell Row",
        "Lateral Raise",
        "Tricep Pushdown"
      ],
      "Squat/Sumo": [
        "Barbell Squat",
        "Sumo Deadlift",
        "Leg Press",
        "Seated Leg Curl"
      ],
      "OHP/Incline": [
        "Overhead Press",
        "Incline Bench Press",
        "Pull-ups",
        "Face Pull",
        "Bicep Curl"
      ],
      "Deadlift/Front Squat": [
        "Deadlift",
        "Front Squat",
        "Barbell Row",
        "Ab Wheel Rollout"
      ]
    }
  }
];
